"use client";

// Génère un cookie court type: 32 chars hex (équivalent bin2hex(random_bytes(16)))
export function generateCookieId(): string {
  return Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

// Récupère l’IP du client
export async function getClientIp(): Promise<string | null> {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const json = await res.json();

    return json.ip ?? null;
  } catch (error) {
    console.error("Erreur récupération IP:", error);
    return null;
  }
}
